import { Skeleton } from "@/components/ui/skeleton";

export function EventsTableSkeleton() {
  return (
    <div className="rounded-md border">
      <div className="p-4">
        {/* Table Header */}
        <div className="flex items-center space-x-4 mb-4">
          <Skeleton className="h-4 w-24" />
          <Skeleton className="h-4 w-32" />
          <Skeleton className="h-4 w-20" />
          <Skeleton className="h-4 w-28" />
          <Skeleton className="h-4 w-24" />
          <Skeleton className="h-4 w-24" />
        </div>

        {/* Table Rows */}
        {Array.from({ length: 8 }).map((_, index) => (
          <div key={index} className="flex items-center space-x-4 mb-3">
            <Skeleton className="h-4 w-24" />
            <Skeleton className="h-4 w-32" />
            <Skeleton className="h-4 w-20" />
            <Skeleton className="h-4 w-28" />
            <Skeleton className="h-4 w-24" />
            <Skeleton className="h-4 w-24" />
          </div>
        ))}
      </div>
    </div>
  );
}
